import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaEnvelope, FaLinkedin } from "react-icons/fa";

function Contactme() {

    const form = useRef();
    const [status, setStatus] = useState("");

    const sendEmail =(e)=> {
        e.preventDefault();

        emailjs.sendForm(
            "service_elshj0a",
            "template_uhgsvpa",
            form.current,
            "t6TyR63ZPEis-aFSI"
        )
        .then(
            ()=> {
                setStatus("Message sent successfully!");
                form.current.reset();
            },
            (error) => {
                setStatus("Failed to send message. Try again later.");
                console.error(error.text);
            }
        );
    };

    return (
        <section id="contact" className="py-20 px-6 bg-[#e3dac9]">
            <h2 className="text-3xl font-bold text-center mb-12 text-[#333]">
                Working on something impactful? <br />
                <span className="text-[#964b00]">Feel free to reach out to me.</span>
                <div className="w-24 h-1 bg-[#964b00] mx-auto mt-2"></div>
            </h2>

            <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
                <div className="bg-white p-8 rounded-lg shadow">
                    <h3 className="text-xl font-semibold text-[#333] mb-6">Send Me a Message</h3>
                    <form ref={form} onSubmit={sendEmail}>
                        <div className="grid md:grid-cols-2 gap-4 mb-4">
                            <input 
                              type="text"
                              name="name"
                              placeholder="Enter Your Name"
                              className="w-full p-3 border border-gray-300 rounded text-black"
                              required
                            />
                            <input 
                              type="email"
                              name="from_email"
                              placeholder="Enter Your Email"
                              className="w-full p-3 border border-gray-300 rounded text-black"
                              required
                            />
                        </div>
                        <input 
                          type="text"
                          name="title"
                          placeholder="Subject"
                          className="w-full mb-4 p-3 border border-gray-300 rounded text-black"
                          required
                        />
                        <textarea
                          rows="5"
                          name="message"
                          placeholder="Your message..."
                          className="w-full p-3 border border-gray-300 rounded text-black"
                          required
                        >
                        </textarea>
                        <button type="submit" className="mt-4 w-full bg-[#987654] text-white py-3 rounded hover:bg-[#c19a6b] transition">
                            Send the Message
                        </button>
                    </form>
                    {status && <p className="mt-4 text-sm text-green-600">{status}</p>}
                </div>

                 <div className="space-y-8">
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-xl font-semibold text-[#333] mb-4">Contact Me</h3>
                        <p className="mb-3 text-gray-700">
                           Feel free to contact me directly via,
                        </p>
                        <div className="flex items-center gap-3 mb-3 text-black">
                             <FaEnvelope className="text-[#964b00] text-xl" /><span>thathyaniweerasinghe@gmail.com</span>
                        </div>
                         <div className="flex items-center gap-3 mb-3 text-black">
                            <FaLinkedin className="text-[#964b00] text-xl" /> <span>Nimrekha Weerasinghe</span>
                         </div>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-xl font-semibold text-[#333] mb-2">I'm Open to work</h3>
                        <p className="mb-3 text-gray-700">
                           I’m actively considering the roles listed below and I am also open to freelance engagements.
                        </p>
                        <div className="bg-[#f0ead6] border-l-4 border-[#964b00] p-4 rounded text-[#964b00]">
                           <strong>Open to work:</strong> Software Quality Engineer, Automation QA Engineer, SDET Engineer, Frontend Engineer
                        </div>
                    </div>
                 </div>

            </div>
        </section>
    )
}

export default Contactme;